import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  header: {
    id: 'WelcomeEventForm.header',
    defaultMessage: 'Welcome Page',
  },
  subheader: {
    id: 'WelcomeEventForm.subheader',
    defaultMessage:
      'This is the first page guests will see when they join your event. This is an opportunity to help your guests know what to share, it will also help personalize the page for your event. This is optional and if not completed, a default page will be shown.',
  },
  headerLabel: {
    id: 'WelcomeEventForm.headerLabel',
    defaultMessage: 'Event Title',
  },
  headerName: {
    id: 'WelcomeEventForm.headerName',
    defaultMessage: 'Event name',
  },
  messageLabel: {
    id: 'WelcomeEventForm.messageLabel',
    defaultMessage: 'Message for Guests',
  },
  messageName: {
    id: 'WelcomeEventForm.messageName',
    defaultMessage: 'Message',
  },
  errorLabel: {
    id: 'WelcomeEventForm.errorLabel',
    defaultMessage: '{field} is required',
  },
  submitButton: {
    id: 'WelcomeEventForm.submitButton',
    defaultMessage: 'Submit',
  },
  uploadPhotoBtn: {
    id: 'WelcomeEventForm.uploadPhotoBtn',
    defaultMessage: 'Upload Photo',
  },
})
